var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0227 16.625L12.8517 12.454C14.097 11.0214 14.7374 9.16128 14.638 7.26572C14.5385 5.37017 13.7071 3.58725 12.3188 2.29274C10.9306 0.998228 9.09396 0.293255 7.19609 0.326405C5.29823 0.359555 3.48735 1.12824 2.14515 2.47044C0.80295 3.81264 0.0342679 5.62351 0.00111827 7.52138C-0.0320314 9.41925 0.672941 11.2559 1.96745 12.6441C3.26196 14.0324 5.04488 14.8638 6.94044 14.9632C8.83599 15.0626 10.6961 14.4222 12.1287 13.177L16.2997 17.348C16.3957 17.4443 16.5258 17.4989 16.6617 17.5C16.7292 17.5004 16.796 17.4871 16.8583 17.461C16.9205 17.4349 16.9768 17.3965 17.0237 17.348C17.1185 17.2515 17.1716 17.1216 17.1714 16.9863C17.1712 16.851 17.1178 16.7212 17.0227 16.625ZM1.03472 7.65501C1.03551 6.41093 1.40514 5.19503 2.09689 4.161C2.78863 3.12698 3.77143 2.32127 4.92103 1.84573C6.07063 1.37019 7.33541 1.24618 8.55548 1.48937C9.77555 1.73256 10.8961 2.33204 11.7755 3.21201C12.655 4.09198 13.2537 5.21294 13.4961 6.43316C13.7385 7.65339 13.6137 8.91809 13.1375 10.0674C12.6612 11.2167 11.8549 12.199 10.8204 12.8901C9.78593 13.5811 8.56979 13.95 7.32572 13.95C5.65728 13.9476 4.05792 13.2835 2.87853 12.1034C1.69914 10.9232 1.03604 9.32344 1.03472 7.65501Z",
    fill: "#0A1E5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.792fc8a9024cd6b453a1e282f0dcf768.svg";
export { ForwardRef as ReactComponent };